(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lre-tte-chapter-network"] && !Shopify.designMode) return;
  try {
    
  class TteChapterNetwork extends HTMLElement {
    connectedCallback() {
      this.search = this.querySelector('[data-network-search]');
      this.district = this.querySelector('[data-network-district]');
      this.state = this.querySelector('[data-network-state]');
      this.tier = this.querySelector('[data-network-tier]');
      this.sort = this.querySelector('[data-network-sort]');
      this.grid = this.querySelector('[data-network-grid]');
      this.empty = this.querySelector('[data-network-empty]');
      this.visibleCount = this.querySelector('[data-visible-count]');
      this.totalCount = this.querySelector('[data-total-count]');
      this.clearButton = this.querySelector('[data-network-clear]');
      this.directory = this.querySelector('.tte-network__directory');
      this.mapRoot = this.querySelector('[data-network-map]');
      this.mapSvg = this.querySelector('[data-us-state-map]');
      this.mapStates = Array.from(this.querySelectorAll('[data-map-state]'));
      this.mapNav = this.querySelector('[data-map-nav]');
      this.mapBack = this.querySelector('[data-map-back]');
      this.mapStateTitle = this.querySelector('[data-map-state-title]');
      this.mapKicker = this.querySelector('[data-map-kicker]');
      this.mapTitle = this.querySelector('[data-map-title]');
      this.mapCopy = this.querySelector('[data-map-copy]');
      this.mapChapterBlock = this.querySelector('[data-map-chapter-block]');
      this.mapChapterList = this.querySelector('[data-map-chapter-list]');
      this.mapChapters = this.querySelector('[data-map-chapters]');
      this.mapOrders = this.querySelector('[data-map-orders]');
      this.mapPieces = this.querySelector('[data-map-pieces]');
      this.mapView = this.querySelector('[data-map-view]');
      this.mapMarkerLayer = this.querySelector('[data-map-markers]');
      this.markerCard = this.querySelector('[data-marker-card]');
      this.markerClose = this.querySelector('[data-marker-close]');
      this.markerSymbols = this.querySelector('[data-marker-symbols]');
      this.markerName = this.querySelector('[data-marker-name]');
      this.markerMeta = this.querySelector('[data-marker-meta]');
      this.markerUniversity = this.querySelector('[data-marker-university]');
      this.markerTier = this.querySelector('[data-marker-tier]');
      this.markerView = this.querySelector('[data-marker-view]');
      this.selectedMapState = '';
      this.activeMarkerCard = null;
      this.nationalViewBox = [0, 0, 820, 560];
      this.currentViewBox = this.nationalViewBox.slice();
      this.mapMarkers = [];
      this.filterShell = this.querySelector('[data-filter-shell]');
      this.filterToggle = this.querySelector('[data-filter-toggle]');
      this.cards = Array.from(this.querySelectorAll('[data-network-card]'));
      this.chips = this.querySelector('[data-district-chips]');
      this.apparelDialog = this.querySelector('[data-apparel-dialog]');
      this.apparelClose = this.querySelector('[data-apparel-close]');
      this.apparelSymbols = this.querySelector('[data-apparel-symbols]');
      this.apparelTitle = this.querySelector('[data-apparel-title]');
      this.apparelContent = this.querySelector('[data-apparel-content]');

      this.populateSelect(this.district, this.cards.map((card) => card.dataset.district), true);
      this.populateSelect(this.state, this.cards.map((card) => card.dataset.state), false);
      this.populateDistrictChips();
      this.updateStats();
      this.initMap();
      this.initChapterMarkers();
      if (this.totalCount) this.totalCount.textContent = String(this.cards.length);

      this.filterToggle?.addEventListener('click', () => {
        const expanded = this.filterShell?.classList.toggle('is-expanded');
        this.filterToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        this.filterToggle.textContent = expanded ? 'Close filters' : 'Filters';
      });

      this.clearButton?.addEventListener('click', () => this.clearFilters());
      this.querySelectorAll('[data-apparel-open]').forEach((button) => {
        button.addEventListener('click', () => this.openApparelDialog(button.closest('[data-network-card]')));
      });
      this.apparelClose?.addEventListener('click', () => this.apparelDialog?.close());
      this.apparelDialog?.addEventListener('click', (event) => {
        if (event.target === this.apparelDialog) this.apparelDialog.close();
      });
      this.markerClose?.addEventListener('click', () => this.closeMarkerCard());
      this.mapBack?.addEventListener('click', () => this.exitStateView(true));
      this.markerView?.addEventListener('click', () => {
        if (!this.activeMarkerCard) return;
        const card = this.activeMarkerCard;
        const stateCode = this.selectedMapState || card.dataset.state || '';
        this.closeMarkerCard();
        this.navigateToChapterDirectory(card, stateCode);
      });

      this.mapView?.addEventListener('click', () => {
        if (!this.selectedMapState) return;
        if (this.activeMarkerCard) {
          this.navigateToChapterDirectory(this.activeMarkerCard, this.selectedMapState);
          return;
        }
        this.navigateToStateDirectory(this.selectedMapState);
      });

      [this.search, this.district, this.state, this.tier, this.sort].forEach((control) => {
        control?.addEventListener('input', () => this.apply());
        control?.addEventListener('change', () => this.apply());
      });

      this.apply();
    }

    openApparelDialog(card) {
      if (!card || !this.apparelDialog || !this.apparelContent) return;
      const template = card.querySelector('[data-apparel-template]');
      if (!template) return;

      if (this.apparelSymbols) this.apparelSymbols.textContent = card.dataset.symbols || '';
      if (this.apparelTitle) this.apparelTitle.textContent = card.dataset.chapter || '';
      this.apparelContent.replaceChildren(template.content.cloneNode(true));

      if (typeof this.apparelDialog.showModal === 'function') this.apparelDialog.showModal();
      else this.apparelDialog.setAttribute('open', '');
    }

        clearFilters() {
      if (this.search) this.search.value = '';
      if (this.district) this.district.value = '';
      if (this.state) this.state.value = '';
      if (this.tier) this.tier.value = '';
      if (this.sort) this.sort.value = 'recent';
      this.apply();
    }

    stateName(code) {
      const state = this.mapStates.find((item) => item.dataset.mapState === code);
      return state?.dataset.stateName || code;
    }

    initMap() {
      if (!this.mapRoot || !this.mapStates.length) return;

      this.mapCounts = {};
      this.cards.forEach((card) => {
        const code = String(card.dataset.state || '').trim().toUpperCase();
        if (!this.mapStates.some((item) => item.dataset.mapState === code)) return;
        if (!this.mapCounts[code]) this.mapCounts[code] = { chapters: 0, orders: 0, pieces: 0, districts: new Set(), chapterCards: [] };
        const item = this.mapCounts[code];
        item.chapters += 1;
        item.chapterCards.push(card);
        item.orders += Number(card.dataset.orders || 0);
        item.pieces += Number(card.dataset.units || 0);
        if (card.dataset.district) item.districts.add(card.dataset.district);
      });

      this.mapStates.forEach((state) => {
        const code = state.dataset.mapState;
        const count = this.mapCounts[code]?.chapters || 0;
        let level = 0;
        if (count >= 10) level = 4;
        else if (count >= 6) level = 3;
        else if (count >= 3) level = 2;
        else if (count >= 1) level = 1;

        state.dataset.level = String(level);
        state.classList.toggle('is-represented', count > 0);
        state.setAttribute('aria-label', count > 0
          ? `${state.dataset.stateName}: ${count} ${count === 1 ? this.mapRoot.dataset.mapChapterOne : this.mapRoot.dataset.mapChapterMany}`
          : `${state.dataset.stateName}: 0 ${this.mapRoot.dataset.mapChapterMany}`);

        if (count > 0) {
          state.setAttribute('tabindex', '0');
          state.setAttribute('role', 'button');
          const activateStateFromTouch = (event) => {
            const now = performance.now();
            const lastTouchSelectAt = Number(state.dataset.lastTouchSelectAt || 0);
            event.preventDefault();
            if (lastTouchSelectAt && now - lastTouchSelectAt < 650) return;
            state.dataset.lastTouchSelectAt = String(now);
            this.selectMapState(code);
          };
          state.addEventListener('pointerup', (event) => {
            if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
            activateStateFromTouch(event);
          });
          state.addEventListener('touchend', activateStateFromTouch, { passive: false });
          state.addEventListener('click', () => {
            const lastTouchSelectAt = Number(state.dataset.lastTouchSelectAt || 0);
            if (lastTouchSelectAt && performance.now() - lastTouchSelectAt < 900) return;
            this.selectMapState(code);
          });
          state.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              this.selectMapState(code);
            }
          });
          state.addEventListener('mouseenter', () => this.updateMapPanel(code));
          state.addEventListener('mouseleave', () => this.updateMapPanel(this.selectedMapState));
          state.addEventListener('focus', () => this.updateMapPanel(code));
          state.addEventListener('blur', () => this.updateMapPanel(this.selectedMapState));
        }
      });

      this.updateMapPanel('');
    }

    projectMapPoint(latitude, longitude, stateCode) {
      const lat = Number(latitude);
      const lng = Number(longitude);
      if (!isFinite(lat) || !isFinite(lng)) return null;

      let box = { x: 18, y: 18, w: 780, h: 390, minX: -125, maxX: -66, minY: 24, maxY: 50 };
      if (stateCode === 'AK') box = { x: 28, y: 394, w: 250, h: 145, minX: -179, maxX: -129, minY: 51, maxY: 72 };
      if (stateCode === 'HI') box = { x: 294, y: 466, w: 142, h: 70, minX: -161, maxX: -154, minY: 18.8, maxY: 22.3 };
      if (stateCode === 'PR') box = { x: 674, y: 500, w: 112, h: 32, minX: -67.3, maxX: -65.2, minY: 17.8, maxY: 18.6 };

      return {
        x: box.x + ((lng - box.minX) / (box.maxX - box.minX)) * box.w,
        y: box.y + ((box.maxY - lat) / (box.maxY - box.minY)) * box.h
      };
    }

    initChapterMarkers() {
      if (!this.mapMarkerLayer) return;
      const ns = 'http://www.w3.org/2000/svg';

      this.cards.forEach((card) => {
        const stateCode = String(card.dataset.state || '').toUpperCase();
        const point = this.projectMapPoint(card.dataset.lat, card.dataset.lng, stateCode);
        if (!point) return;

        const marker = document.createElementNS(ns, 'g');
        marker.classList.add('tte-us-map__marker');
        marker.dataset.markerState = stateCode;
        marker.setAttribute('transform', `translate(${point.x.toFixed(2)} ${point.y.toFixed(2)})`);
        marker.setAttribute('tabindex', '-1');
        marker.setAttribute('role', 'button');
        marker.setAttribute('aria-label', `${card.dataset.chapter}, ${card.dataset.state}`);
        marker.hidden = true;
        marker.style.display = 'none';

        const circle = document.createElementNS(ns, 'circle');
        circle.setAttribute('r', '4.8');
        marker.append(circle);

        const open = () => this.openMarkerCard(card, marker);
        marker.addEventListener('click', open);
        marker.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            open();
          }
        });

        this.mapMarkerLayer.append(marker);
        this.mapMarkers.push({ marker, card, circle, stateCode });
      });
    }

    openChapterFromStatePanel(card) {
      if (!card) return;
      const stateCode = String(card.dataset.state || '').trim().toUpperCase();
      if (stateCode && this.selectedMapState !== stateCode && this.mapCounts?.[stateCode]) {
        this.enterStateView(stateCode, false);
      }
      const markerItem = this.mapMarkers.find((item) => item.card === card);
      if (!markerItem) return;
      this.openMarkerCard(card, markerItem.marker);
    }

        highlightChapterMarker(card) {
      if (!card) return;
      this.mapMarkers.forEach((item) => {
        item.marker.classList.toggle('is-active', item.card === card);
      });
    }

    restoreMarkerHighlight() {
      this.mapMarkers.forEach((item) => {
        item.marker.classList.toggle('is-active', Boolean(this.activeMarkerCard) && item.card === this.activeMarkerCard);
      });
    }

    highlightChapterPill(card) {
      if (!this.mapChapterList) return;
      this.mapChapterList.querySelectorAll('button').forEach((button) => {
        button.classList.toggle('is-active', button.dataset.chapterName === (card?.dataset.chapter || ''));
      });
    }

        openMarkerCard(card, marker) {
      if (!this.markerCard) return;
      this.activeMarkerCard = card;
      this.querySelectorAll('.tte-us-map__marker.is-active').forEach((item) => item.classList.remove('is-active'));
      marker?.classList.add('is-active');
      this.highlightChapterPill(card);

      if (this.markerSymbols) this.markerSymbols.textContent = card.dataset.symbols || '';
      if (this.markerName) this.markerName.textContent = card.dataset.chapter || '';
      if (this.markerMeta) this.markerMeta.textContent = [this.districtLabel(card.dataset.district), card.dataset.state].filter(Boolean).join(' · ');
      if (this.markerUniversity) {
        this.markerUniversity.textContent = card.dataset.university || '';
        this.markerUniversity.hidden = !card.dataset.university;
      }
      if (this.markerTier) this.markerTier.textContent = card.dataset.tier || '';
      this.markerCard.hidden = false;
    }

    closeMarkerCard() {
      this.activeMarkerCard = null;
      this.querySelectorAll('.tte-us-map__marker.is-active').forEach((item) => item.classList.remove('is-active'));
      this.highlightChapterPill(null);
      if (this.markerCard) this.markerCard.hidden = true;
    }

        setDirectoryFilters(stateCode, chapterName) {
      if (this.search) this.search.value = chapterName || '';
      if (this.district) this.district.value = '';
      if (this.state) this.state.value = stateCode || '';
      if (this.tier) this.tier.value = '';
      if (this.sort) this.sort.value = 'recent';
      this.apply({ syncMap: false });
    }

    resetDirectoryFiltersForState(code) {
      this.setDirectoryFilters(code, '');
    }

    scrollToDirectoryTarget(target, alignToCard) {
      if (!target) return;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const behavior = reducedMotion ? 'auto' : 'smooth';

      const run = () => {
        target.scrollIntoView({
          behavior,
          block: 'start',
          inline: 'nearest'
        });

        if (alignToCard) {
          target.setAttribute('tabindex', '-1');
          window.setTimeout(() => target.focus({ preventScroll: true }), reducedMotion ? 0 : 520);
        }
      };

      window.requestAnimationFrame(() => window.requestAnimationFrame(run));
    }

    navigateToStateDirectory(stateCode) {
      if (!stateCode) return;
      this.closeMarkerCard();
      this.setDirectoryFilters(stateCode, '');
      this.scrollToDirectoryTarget(this.directory, false);
    }

    navigateToChapterDirectory(card, stateCode) {
      if (!card) return;
      this.closeMarkerCard();
      this.setDirectoryFilters(stateCode || card.dataset.state || '', card.dataset.chapter || '');
      if (card.hidden) return;
      this.scrollToDirectoryTarget(card, true);
    }

    animateMapViewBox(target) {
      if (!this.mapSvg) return;
      const start = this.currentViewBox.slice();
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reducedMotion) {
        this.currentViewBox = target.slice();
        this.mapSvg.setAttribute('viewBox', target.join(' '));
        return;
      }

      const startedAt = performance.now();
      const duration = 420;
      const ease = (value) => 1 - Math.pow(1 - value, 3);

      const frame = (now) => {
        const progress = Math.min((now - startedAt) / duration, 1);
        const eased = ease(progress);
        const next = start.map((value, index) => value + (target[index] - value) * eased);
        this.mapSvg.setAttribute('viewBox', next.join(' '));

        if (progress < 1) {
          window.requestAnimationFrame(frame);
        } else {
          this.currentViewBox = target.slice();
        }
      };

      window.requestAnimationFrame(frame);
    }

    stateViewBox(code) {
      const state = this.mapStates.find((item) => item.dataset.mapState === code);
      if (!state) return this.nationalViewBox.slice();

      const box = state.getBBox();
      const paddingX = Math.max(box.width * 0.22, 14);
      const paddingY = Math.max(box.height * 0.22, 14);
      const centerX = box.x + box.width / 2;
      const centerY = box.y + box.height / 2;
      const targetRatio = this.nationalViewBox[2] / this.nationalViewBox[3];

      let width = box.width + paddingX * 2;
      let height = box.height + paddingY * 2;

      if (width / height < targetRatio) {
        width = height * targetRatio;
      } else {
        height = width / targetRatio;
      }

      return [
        centerX - width / 2,
        centerY - height / 2,
        width,
        height
      ];
    }

    updateMarkerVisibility(code, viewBox) {
      const markerRadius = code && viewBox
        ? Math.max(0.55, 4.8 * (viewBox[2] / this.nationalViewBox[2]))
        : 4.8;

      this.mapMarkers.forEach((item) => {
        const visible = Boolean(code) && item.stateCode === code;
        item.marker.hidden = !visible;
        item.marker.style.display = visible ? '' : 'none';
        item.marker.setAttribute('tabindex', visible ? '0' : '-1');
        item.circle.setAttribute('r', String(markerRadius));
        if (!visible) item.marker.classList.remove('is-active');
      });
    }

    enterStateView(code, updatePanel = true) {
      if (!code || !this.mapCounts?.[code] || !this.mapSvg) return;

      const stateChanged = this.selectedMapState !== code;
      this.closeMarkerCard();
      this.selectedMapState = code;
      if (stateChanged) this.resetDirectoryFiltersForState(code);
      const targetViewBox = this.stateViewBox(code);

      this.mapSvg.classList.add('is-state-detail');
      this.mapStates.forEach((state) => {
        const selected = state.dataset.mapState === code;
        state.classList.toggle('is-selected', selected);
        state.classList.toggle('is-outside-state', !selected);
      });

      if (this.mapNav) this.mapNav.hidden = false;
      if (this.mapStateTitle) this.mapStateTitle.textContent = this.stateName(code);
      this.updateMarkerVisibility(code, targetViewBox);
      this.animateMapViewBox(targetViewBox);
      if (updatePanel) this.updateMapPanel(code);
    }

    exitStateView(updatePanel = true) {
      this.closeMarkerCard();
      this.selectedMapState = '';

      if (this.mapSvg) this.mapSvg.classList.remove('is-state-detail');
      this.mapStates.forEach((state) => {
        state.classList.remove('is-selected', 'is-outside-state');
      });

      if (this.mapNav) this.mapNav.hidden = true;
      if (this.mapStateTitle) this.mapStateTitle.textContent = '';
      this.updateMarkerVisibility('', this.nationalViewBox);
      this.animateMapViewBox(this.nationalViewBox);
      if (updatePanel) this.updateMapPanel('');
    }

    selectMapState(code) {
      this.enterStateView(code, true);
    }

    syncMapSelection(code) {
      if (!code) {
        if (this.selectedMapState) this.exitStateView(true);
        return;
      }
      if (!this.mapCounts?.[code]) return;
      if (this.selectedMapState !== code) this.enterStateView(code, true);
      else this.updateMapPanel(code);
    }

    updateMapPanel(code) {
      if (!this.mapRoot || !this.mapTitle) return;

      if (code && this.mapCounts?.[code]) {
        const item = this.mapCounts[code];
        const chapterWord = item.chapters === 1 ? this.mapRoot.dataset.mapChapterOne : this.mapRoot.dataset.mapChapterMany;
        this.mapKicker.textContent = this.stateName(code);
        this.mapTitle.textContent = `${item.chapters} ${chapterWord}`;
        if (this.mapCopy) this.mapCopy.hidden = true;
        if (this.mapChapterBlock) this.mapChapterBlock.hidden = false;
        if (this.mapChapterList) {
          this.mapChapterList.replaceChildren();
          item.chapterCards
            .slice()
            .sort((a, b) => String(a.dataset.chapter || '').localeCompare(String(b.dataset.chapter || '')))
            .forEach((card) => {
              const pill = document.createElement('button');
              pill.type = 'button';
              pill.textContent = card.dataset.symbols || card.dataset.chapter || '';
              pill.dataset.chapterName = card.dataset.chapter || '';
              pill.setAttribute('aria-label', `View ${card.dataset.chapter || 'chapter'} representation`);
              pill.addEventListener('click', () => this.openChapterFromStatePanel(card));
              pill.addEventListener('mouseenter', () => this.highlightChapterMarker(card));
              pill.addEventListener('focus', () => this.highlightChapterMarker(card));
              pill.addEventListener('mouseleave', () => this.restoreMarkerHighlight());
              pill.addEventListener('blur', () => this.restoreMarkerHighlight());
              this.mapChapterList.append(pill);
            });
        }
        this.mapChapters.textContent = String(item.chapters);
        this.mapOrders.textContent = String(item.orders);
        this.mapPieces.textContent = String(item.pieces);
        if (this.mapView) this.mapView.hidden = false;
        return;
      }

      const codes = Object.keys(this.mapCounts || {}).filter((stateCode) => this.mapCounts[stateCode].chapters > 0);
      const totals = codes.reduce((sum, stateCode) => {
        const item = this.mapCounts[stateCode];
        sum.chapters += item.chapters;
        sum.orders += item.orders;
        sum.pieces += item.pieces;
        return sum;
      }, { chapters: 0, orders: 0, pieces: 0 });

      const locationWord = codes.length === 1 ? this.mapRoot.dataset.mapLocationOne : this.mapRoot.dataset.mapLocationMany;
      this.mapKicker.textContent = this.mapRoot.dataset.mapAllLabel;
      this.mapTitle.textContent = `${codes.length} ${locationWord}`;
      if (this.mapCopy) {
        this.mapCopy.hidden = false;
        this.mapCopy.textContent = this.mapRoot.dataset.mapHint;
      }
      if (this.mapChapterBlock) this.mapChapterBlock.hidden = true;
      if (this.mapChapterList) this.mapChapterList.replaceChildren();
      this.mapChapters.textContent = String(totals.chapters);
      this.mapOrders.textContent = String(totals.orders);
      this.mapPieces.textContent = String(totals.pieces);
      if (this.mapView) this.mapView.hidden = true;
    }

    districtLabel(value) {
      const number = Number(value);
      const suffix =
        number % 100 >= 11 && number % 100 <= 13
          ? 'th'
          : number % 10 === 1
            ? 'st'
            : number % 10 === 2
              ? 'nd'
              : number % 10 === 3
                ? 'rd'
                : 'th';
      return `${number}${suffix} District`;
    }

    populateSelect(select, values, numeric) {
      if (!select) return;
      const unique = [...new Set(values.filter(Boolean))];
      unique.sort((a, b) => numeric ? Number(a) - Number(b) : a.localeCompare(b));
      unique.forEach((value) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = numeric ? this.districtLabel(value) : value;
        select.append(option);
      });
    }

    populateDistrictChips() {
      if (!this.chips) return;
      const districts = [...new Set(this.cards.map((card) => card.dataset.district).filter(Boolean))]
        .sort((a, b) => Number(a) - Number(b));

      districts.forEach((district) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'tte-network__district-chip';
        button.textContent = this.districtLabel(district);
        button.dataset.districtChip = district;
        button.setAttribute('aria-pressed', 'false');
        button.addEventListener('click', () => {
          const isActive = button.getAttribute('aria-pressed') === 'true';
          this.querySelectorAll('[data-district-chip]').forEach((chip) => chip.setAttribute('aria-pressed', 'false'));
          if (this.district) this.district.value = isActive ? '' : district;
          if (!isActive) button.setAttribute('aria-pressed', 'true');
          this.apply();
        });
        this.chips.append(button);
      });
    }

    updateStats() {
      const pieces = this.cards.reduce((sum, card) => sum + Number(card.dataset.units || 0), 0);
      const strong = this.cards.filter((card) => card.dataset.tier === 'Strong Representation').length;
      const legacy = this.cards.filter((card) => card.dataset.tier === 'Legacy Supporter').length;
      const total = this.querySelector('[data-stat-total]');
      const piecesCount = this.querySelector('[data-stat-pieces]');
      const strongCount = this.querySelector('[data-stat-strong]');
      const legacyCount = this.querySelector('[data-stat-legacy]');
      if (total) total.textContent = String(this.cards.length);
      if (piecesCount) piecesCount.textContent = pieces.toLocaleString();
      if (strongCount) strongCount.textContent = String(strong);
      if (legacyCount) legacyCount.textContent = String(legacy);
    }

    apply(options = {}) {
      const query = (this.search?.value || '').trim().toLowerCase();
      const districtSearchMatch = query.match(/(?:district\s*)?(\d{1,2})(?:st|nd|rd|th)?(?:\s*district)?/i);
      const typedDistrict = districtSearchMatch && /district/i.test(query)
        ? String(Number(districtSearchMatch[1]))
        : '';
      const district = this.district?.value || '';
      const state = this.state?.value || '';
      const tier = this.tier?.value || '';

      let visible = 0;
      this.cards.forEach((card) => {
        const matches =
          (!query || card.dataset.search.includes(query) || (typedDistrict && card.dataset.district === typedDistrict)) &&
          (!district || card.dataset.district === district) &&
          (!state || card.dataset.state === state) &&
          (!tier || card.dataset.tier === tier);
        card.hidden = !matches;
        if (matches) visible += 1;
      });

      this.sortCards();
      if (this.visibleCount) this.visibleCount.textContent = String(visible);
      if (this.empty) this.empty.hidden = visible !== 0;
      if (options.syncMap !== false) this.syncMapSelection(state);

      const filtersActive =
        query ||
        district ||
        state ||
        tier ||
        (this.sort && this.sort.value !== 'recent');
      if (this.clearButton) this.clearButton.hidden = !filtersActive;

      this.querySelectorAll('[data-district-chip]').forEach((chip) => {
        chip.setAttribute('aria-pressed', chip.dataset.districtChip === district ? 'true' : 'false');
      });
    }

    sortCards() {
      if (!this.grid) return;
      const mode = this.sort?.value || 'recent';
      const sorted = [...this.cards].sort((a, b) => {
        if (mode === 'chapter') return a.dataset.chapter.localeCompare(b.dataset.chapter);
        if (mode === 'orders') return Number(b.dataset.orders || 0) - Number(a.dataset.orders || 0);
        if (mode === 'district') return Number(a.dataset.district || 0) - Number(b.dataset.district || 0) || a.dataset.chapter.localeCompare(b.dataset.chapter);
        return String(b.dataset.latest || '').localeCompare(String(a.dataset.latest || ''));
      });
      sorted.forEach((card) => this.grid.append(card));
    }
  }

  if (!customElements.get('tte-chapter-network')) {
    customElements.define('tte-chapter-network', TteChapterNetwork);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
